import React, { useEffect, useState } from "react";
import "./base.min.css";
import "./fancy.min.css";
import "./security.css";
import axios from "axios";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

const PDF = (props) => {
  const url = `${process.env.REACT_APP_API_URL}user/agreement/sign`;

  const [checked, setChecked] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    const div = document.querySelector("#sidebar");
    const script = document.createElement("script");
    const script2 = document.createElement("script");
    script.async = true;
    script2.async = true;
    script.src = "./compatibility.min.js";
    script2.src = "./pdf2htmlEX.min.js";
    div.appendChild(script);
    div.appendChild(script2);
  }, []);

  const handleChange = (e) => {
    if (checked) {
      setChecked(false);
    } else {
      setChecked(true);
    }
  };

  const sendForm = async () => {
    setIsLoading(true)

    try {
      const data = {
        signkey: props.id,
        signeddoc: true
      };
      const response = await axios({
        method: 'POST',
        url: url,
        data: data
      });

      if (response && response.status === 200) {
        setIsLoading(false)
        props.isDocSignedFn(true)

      }

    } catch (err) {

      if (err.response.status === 401) {
        setErrorMsg("Error: You are not Authorized, try again");
      } else if (err.response.status === 422) {
        setErrorMsg("Error: You sent bad data, try again");
      } else if (err.request) {
        setErrorMsg("Error: Server responded with and error, try again");
      }
      setIsLoading(false)
    }

  };

  return (
    <div>
      <div id="sidebar">
        <div id="outline"></div>
      </div>
      <div id="page-container">
        <div id="pf1" className="pf w0 h0" data-page-no={1}>
          <div className="pc pc1 w0 h0">
            <img
              className="bi x0 y0 w1 h1"
              alt=""
              src="data:image/png;base64,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"
            />
            <div className="c x1 y1 w2 h0">
              <div className="t m0 x2 h2 y2 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y3 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y4 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h3 y5 ff1 fs1 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x3 h4 y6 ff2 fs2 fc1 sc0 ls0 ws0">
                Stay
                <span className="_ _0" /> S<span className="_ _0" />
                afe{" "}
              </div>
              <div className="t m0 x3 h4 y7 ff2 fs2 fc1 sc0 ls0 ws0">
                at Ingka{" "}
              </div>
              <div className="t m0 x3 h4 y8 ff2 fs2 fc1 sc0 ls0 ws0">
                Offices{" "}
              </div>
              <div className="t m0 x3 h4 y9 ff2 fs2 fc1 sc0 ls0 ws0">
                in Malmö{" "}
              </div>
              <div className="t m0 x3 h5 ya ff2 fs3 fc1 sc0 ls0 ws0"> </div>
              <div className="t m0 x3 h5 yb ff2 fs3 fc1 sc0 ls0 ws0">
                Safe
                <span className="_ _0" />
                ty &amp; S<span className="_ _0" />
                ecu
                <span className="_ _0" />
                rity I<span className="_ _0" />
                nfor
                <span className="_ _0" />
                matio
                <span className="_ _0" />n{" "}
              </div>
              <div className="t m0 x3 h5 yc ff2 fs3 fc1 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 yd ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 ye ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 yf ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y10 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y11 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y12 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y13 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y14 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y15 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y16 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y17 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y18 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y19 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y1a ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y1b ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y1c ff1 fs0 fc0 sc0 ls0 ws0"> </div>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.300000,0.000000,0.000000,1.300000,0.000000,0.000000]}'
          />
        </div>
        <div id="pf2" className="pf w0 h0" data-page-no={2}>
          <div className="pc pc2 w0 h0">
            <img
              className="bi x4 y1d w3 h6"
              alt=""
              src="data:image/png;base64,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"
            />
            <div className="c x1 y1 w2 h0">
              <div className="t m0 x5 h7 y1e ff3 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x5 h2 y1f ff1 fs0 fc0 sc0 ls0 ws0">
                {" "}
                <span className="ls1">
                  {" "}
                  <span className="_ _1"> </span>
                </span>{" "}
              </div>
              <div className="t m0 x5 h8 y20 ff1 fs4 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x6 h2 y21 ff1 fs0 fc2 sc0 ls2 ws0">
                We
                <span className="ls0">
                  {" "}
                  <span className="_ _2" />
                  strive <span className="_ _2" />
                  to <span className="_ _2" />
                  have <span className="_ _2" />
                  safe <span className="_ _2" />
                  workplace
                  <span className="_ _3" />
                  s. <span className="_ _2" />
                  This <span className="_ _2" />l<span className="_ _0" />
                  eaflet <span className="_ _2" />
                  is <span className="_ _2" />
                  de
                  <span className="_ _3" />
                  signed <span className="_ _2" />
                  to <span className="_ _2" />
                  inform <span className="_ _2" />
                  you <span className="_ _2" />
                  as <span className="_ _2" />a <span className="_ _2" />
                  <span className="ls3">co</span>-worker{" "}
                  <span className="_ _2" />
                  of <span className="_ _2" />
                  the <span className="_ _2" />
                  possible <span className="_ _2" />
                  risks{" "}
                </span>
              </div>
              <div className="t m0 x6 h2 y22 ff1 fs0 fc2 sc0 ls0 ws0">
                and how we work wit
                <span className="_ _3" />h security{" "}
                <span className="ls4">at</span> <span className="_ _0" />I
                <span className="_ _0" />K<span className="_ _0" />E
                <span className="_ _0" />A<span className="_ _0" />.
              </div>
              <div className="t m0 x5 h2 y23 ff1 fs0 fc2 sc0 ls0 ws0">
                {" "}
                <span className="_ _4"> </span>{" "}
              </div>
              <div className="t m0 x6 h9 y24 ff2 fs0 fc2 sc0 ls0 ws0">
                IKEA safety <span className="_ _0" />
                rules:
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x7 ha y25 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Protect human <span className="_ _0" />
                    life, you
                    <span className="_ _0" /> and me, <span className="_ _0" />
                    <span className="ls3">
                      co
                      <span className="ls0">
                        -workers and <span className="_ _0" />
                        visitors.
                        <span className="_ _0" />{" "}
                      </span>
                    </span>
                  </span>
                </span>
              </div>
              <div className="t m0 x7 ha y26 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Prevent <span className="_ _0" />
                    damage <span className="ls5">to</span>{" "}
                    <span className="_ _0" />
                    people, property and <span className="_ _0" />
                    loss <span className="_ _0" />
                    <span className="ls6">
                      of
                      <span className="ls0">
                        {" "}
                        <span className="_ _0" />
                        information.{" "}
                      </span>
                    </span>
                  </span>
                </span>
              </div>
              <div className="t m0 x7 ha y27 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Securing <span className="ls6">our</span> j
                    <span className="_ _0" />
                    obs and <span className="_ _0" />
                    the future <span className="_ _0" />
                    <span className="ls6">
                      of<span className="ls0"> IKEA. </span>
                    </span>
                  </span>
                </span>
              </div>
              <div className="t m0 x5 h9 y28 ff2 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x6 h2 y29 ff2 fs0 fc2 sc0 ls0 ws0">
                How do we
                <span className="_ _0" /> achieve a safe IKEA?
                <span className="ff1"> </span>
              </div>
              <div className="t m0 x5 hb y2a ff1 fs5 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x7 ha y2b ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    By following the codes
                    <span className="_ _3" /> of cond
                    <span className="_ _3" />
                    uct and established
                    <span className="_ _3" /> safety routines.{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x5 hb y2c ff1 fs5 fc3 sc0 ls0 ws0"> </div>
              <div className="t m0 x7 ha y2d ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Correct errors and fau
                    <span className="_ _3" />
                    lts when you see <span className="_ _3" />
                    them
                    <span className="_ _3" />.{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x5 hb y2e ff1 fs5 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x7 ha y2f ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Report and follow up o<span className="_ _3" />n incidents
                    and <span className="_ _3" />
                    injuries.{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x8 hc y30 ff1 fs6 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x9 h2 y31 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x5 hd y32 ff1 fs7 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 xa h2 y33 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y34 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y35 ff1 fs0 fc2 sc0 ls0 ws0">
                The <span className="_ _2" />
                relation <span className="_ _2" />
                between <span className="_ _2" />
                you, <span className="_ _2" />
                as <span className="_ _2" />a<span className="_ _3" />{" "}
                <span className="_ _2" />
                <span className="ls3">co</span>-wor
                <span className="_ _0" />
                ker, <span className="_ _2" />
                and <span className="_ _3" />
                IKEA, <span className="_ _2" />
                as <span className="_ _2" />
                an employe
                <span className="_ _3" />
                r, <span className="_ _3" />
                includes <span className="_ _3" />
                several <span className="_ _3" />
                general{" "}
              </div>
              <div className="t m0 x2 h2 y36 ff1 fs0 fc2 sc0 ls0 ws0">
                rules. <span className="_ _6"> </span>Among{" "}
                <span className="_ _6"> </span>other{" "}
                <span className="_ _6"> </span>things,
              </div>
              <div className="t m1 xb h2 y36 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 xc h2 y36 ff1 fs0 fc2 sc0 ls0 ws0">
                IKEA has <span className="_ _7"> </span>a contractual right to{" "}
                <span className="_ _7"> </span>determine how and when{" "}
                <span className="_ _7"> </span>the
              </div>
              <div className="t m1 xd h2 y36 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y37 ff6 fs0 fc2 sc0 ls0 ws0">
                company’s
                <span className="ff1">
                  {" "}
                  pr
                  <span className="_ _0" />
                  opert
                  <span className="_ _3" />y <span className="_ _0" />
                  <span className="ls7">
                    may
                    <span className="ls0">
                      {" "}
                      <span className="_ _0" />
                      <span className="ls8">
                        be
                        <span className="ls0">
                          {" "}
                          <span className="_ _0" />
                          used.{" "}
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </div>
              <div className="t m0 xe h2 y38 ff1 fs0 fc2 sc0 ls0 ws0">
                At IKEA, the following ge
                <span className="_ _3" />
                neral rules <span className="_ _3" />
                appl
                <span className="_ _3" />
                y:{" "}
              </div>
              <div className="t m0 x2 ha y39 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    All entries and exits sho
                    <span className="_ _3" />
                    uld be done v<span className="_ _3" />
                    ia the <span className="_ _3" />
                    main entrance
                    <span className="_ _3" />
                    <span className="ls9">s.</span>{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x2 ha y3a ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Always wear your IK
                    <span className="_ _3" />
                    EA <span className="lsa">ID</span>-card{" "}
                    <span className="_ _3" />
                    visibly.{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x2 ha y3b ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Notify <span className="_ _8" />
                    security <span className="_ _8" />
                    if <span className="_ _8" />
                    you <span className="_ _8" />
                    see <span className="_ _8"> </span>unauthor
                    <span className="_ _3" />
                    ized <span className="_ _8" />
                    people <span className="_ _8"> </span>within{" "}
                    <span className="_ _8"> </span>IKEA{" "}
                    <span className="_ _8" />
                    property. <span className="_ _8"> </span>Don´t{" "}
                    <span className="_ _8"> </span>let{" "}
                    <span className="_ _8"> </span>someone{" "}
                    <span className="_ _9"> </span>in{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 xf h2 y3c ff1 fs0 fc2 sc0 ls0 ws0">
                without valid IKEA card
                <span className="_ _3" />.<span className="_ _3" />{" "}
              </div>
              <div className="t m0 x2 ha y3d ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Be aware of incidents <span className="_ _3" />
                    such as f<span className="_ _3" />
                    ire or theft of personal
                    <span className="_ _3" /> <span className="_ _3" />
                    property as <span className="_ _3" />
                    well as company pr
                    <span className="_ _3" />
                    operty.
                    <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 xf h2 y3e ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 ha y3f ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    If som
                    <span className="_ _3" />
                    eone falls <span className="_ _3" />
                    ill <span className="_ _3" />
                    or <span className="_ _3" />
                    gets <span className="_ _3" />
                    hurt <span className="_ _3" />
                    and <span className="_ _3" />
                    need
                    <span className="_ _3" />s a<span className="_ _3" />n{" "}
                    <span className="_ _3" />
                    ambula
                    <span className="_ _3" />
                    nce, call <span className="_ _3" />
                    112 <span className="_ _3" />
                    to S<span className="_ _3" />
                    OS
                    <span className="_ _3" />. <span className="_ _3" />
                    Please <span className="_ _3" />
                    notify the
                    <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 xf h2 y40 ff1 fs0 fc2 sc0 ls0 ws0">
                Startbox/guard that y<span className="_ _3" />
                ou have ca
                <span className="_ _3" />
                lled SOS.{" "}
              </div>
              <div className="t m0 x2 ha y41 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Threats <span className="_ _a"> </span>and{" "}
                    <span className="_ _a"> </span>violence{" "}
                    <span className="_ _a"> </span>ar
                    <span className="_ _3" />e <span className="_ _a"> </span>
                    not <span className="_ _a"> </span>tolerated{" "}
                    <span className="_ _a"> </span>and{" "}
                    <span className="_ _a"> </span>should{" "}
                    <span className="_ _a"> </span>always{" "}
                    <span className="_ _a"> </span>be{" "}
                    <span className="_ _a"> </span>repo
                    <span className="_ _3" />
                    rted <span className="_ _a"> </span>to{" "}
                    <span className="_ _a"> </span>the{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 xf h2 y42 ff1 fs0 fc2 sc0 ls0 ws0">
                immediate superv
                <span className="_ _3" />
                isor.{" "}
              </div>
              <div className="t m0 x2 ha y43 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Bomb threats <span className="ff6">–</span>{" "}
                    <span className="_ _3" />
                    contact the <span className="_ _3" />
                    Startbox.{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x2 ha y44 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    No smoking is allowed <span className="_ _3" />
                    in or around IKEA pr
                    <span className="_ _3" />
                    operties <span className="_ _2" />
                    except for designated smoking a<span className="_ _3" />
                    reas.
                    <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x2 ha y45 ff4 fs0 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    At IKEA we have zero to
                    <span className="_ _3" />
                    lerance to a<span className="_ _3" />
                    lcohol and drugs
                    <span className="_ _3" />.<span className="fc2"> </span>{" "}
                  </span>
                </span>
              </div>
            </div>
            <div className="c x4 y46 w4 he">
              <div className="t m0 x10 hf y47 ff7 fs6 fc1 sc0 ls0 ws0">
                OUR <span className="_ _0" />
                SECURIT
                <span className="_ _0" />Y <span className="ff8">–</span>{" "}
                <span className="_ _0" />
                YOUR <span className="_ _0" />
                SAFETY<span className="ff9"> </span>
              </div>
            </div>
            <div className="c x2 y33 w5 h10">
              <div className="t m0 x10 hf y48 ff7 fs6 fc1 sc0 ls0 ws0">
                GENERAL RULES
                <span className="_ _0" />
                <span className="ff9"> </span>
              </div>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.300000,0.000000,0.000000,1.300000,0.000000,0.000000]}'
          />
        </div>
        <div id="pf3" className="pf w0 h0" data-page-no={3}>
          <div className="pc pc3 w0 h0">
            <img
              className="bi x2 y49 w6 h11"
              alt=""
              src="data:image/png;base64,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"
            />
            <div className="c x1 y1 w2 h0">
              <div className="t m0 x2 h7 y4a ff3 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 ha y4b ff4 fs0 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1 fc2">
                    You, <span className="_ _3" />
                    as <span className="_ _2" />a <span className="_ _3" />
                    co-wo
                    <span className="_ _3" />
                    rker, <span className="_ _3" />s<span className="_ _3" />
                    hould <span className="_ _2" />
                    turn <span className="_ _3" />
                    off <span className="_ _2" />
                    all <span className="_ _3" />
                    electr
                    <span className="_ _3" />
                    ic <span className="_ _3" />
                    eq
                    <span className="_ _3" />
                    uipment, <span className="_ _3" />s<span className="_ _3" />
                    uch <span className="_ _3" />
                    as <span className="_ _2" />
                    screens <span className="_ _3" />a<span className="_ _3" />
                    nd/or <span className="_ _2" />
                    lights{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 xf h2 y4c ff1 fs0 fc2 sc0 ls0 ws0">
                at the end of the da
                <span className="_ _3" />
                y.<span className="fc0"> </span>
              </div>
              <div className="t m0 x2 ha y4d ff4 fs0 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    The alarm will automatica
                    <span className="_ _3" />
                    lly activate a<span className="_ _3" />t 21.00. Please{" "}
                    <span className="_ _3" />
                    leave the building befo
                    <span className="_ _3" />
                    re this time. <span className="_ _2" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x2 ha y4e ff4 fs0 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    When it <span className="_ _3" />
                    comes <span className="_ _3" />
                    to <span className="_ _3" />
                    safety <span className="_ _3" />
                    &amp; <span className="_ _3" />
                    security <span className="_ _3" />
                    issues, <span className="_ _3" />
                    instru
                    <span className="_ _3" />
                    ct
                    <span className="_ _3" />
                    ions from
                    <span className="_ _3" /> sa
                    <span className="_ _3" />
                    fety pe
                    <span className="_ _3" />
                    rsonnel <span className="_ _3" />
                    is <span className="_ _3" />
                    always <span className="_ _3" />
                    to <span className="_ _3" />
                    be{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 xf h2 y4f ff1 fs0 fc0 sc0 ls0 ws0">
                followed.{" "}
              </div>
              <div className="t m0 x2 h12 y50 ff4 fs8 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _b"> </span>
                  <span className="ff1 fs0">
                    Equipment or pers
                    <span className="_ _3" />
                    onal items <span className="_ _3" />
                    left overnight in the d<span className="_ _3" />
                    ay
                    <span className="_ _3" />
                    -time lockers w<span className="_ _3" />
                    ill be removed
                    <span className="_ _3" />. <span className="fs8"> </span>
                  </span>
                </span>
              </div>
              <div className="t m0 x2 h12 y51 ff4 fs8 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _b"> </span>
                  <span className="ff1 fs0">
                    Valuables <span className="_ _8" />
                    will <span className="_ _8" />
                    be <span className="_ _8" />
                    stored <span className="_ _8" />
                    for <span className="_ _8" />3 <span className="_ _8" />
                    months <span className="_ _8"> </span>befo
                    <span className="_ _3" />
                    re <span className="_ _8" />
                    being <span className="_ _8"> </span>handed{" "}
                    <span className="_ _8" />
                    over <span className="_ _8" />
                    to <span className="_ _8" />
                    the <span className="_ _8" />
                    police
                    <span className="_ _3" /> <span className="_ _8" />
                    while <span className="_ _8" />
                    other{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 xf h2 y52 ff1 fs0 fc0 sc0 ls0 ws0">
                items will be stored f<span className="_ _3" />
                or 1 month before bei
                <span className="_ _3" />
                ng
                <span className="_ _3" /> recyc
                <span className="_ _3" />
                led.<span className="fs8"> </span>
              </div>
              <div className="t m0 x11 h2 y53 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x12 h2 y54 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x13 h2 y55 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 xe h13 y56 ff1 fs9 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 xe h2 y57 ff1 fs0 fc2 sc0 ls0 ws0">
                If you receive visits you are a<span className="_ _3" />
                lways responsible for your visitor
                <span className="_ _c" />.{" "}
              </div>
              <div className="t m0 x2 h2 y58 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha y59 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Visitors should a<span className="_ _3" />
                    lways sign in/
                    <span className="_ _3" />
                    out and be picked <span className="_ _3" />
                    up and <span className="_ _3" />
                    dropped off
                    <span className="_ _3" /> by their host.
                    <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x14 ha y5a ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    The visitors ID
                    <span className="_ _3" />
                    -badge sho
                    <span className="_ _3" />
                    uld always be visible
                    <span className="_ _3" />.{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x14 ha y5b ff4 fs0 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Take <span className="_ _2" />
                    privacy <span className="_ _3" />a<span className="_ _3" />
                    nd <span className="_ _3" />
                    co
                    <span className="_ _3" />
                    nfidentiality <span className="_ _2" />
                    into <span className="_ _2" />
                    consideration <span className="_ _2" />
                    when <span className="_ _3" />
                    bo
                    <span className="_ _3" />
                    oking <span className="_ _2" />
                    meeting <span className="_ _2" />
                    rooms <span className="_ _3" />
                    at
                    <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 y5c ff1 fs0 fc0 sc0 ls0 ws0">
                the office floor and whe
                <span className="_ _3" />n escorting v<span className="_ _3" />
                isitors through
                <span className="_ _3" /> the building.
                <span className="_ _2" />{" "}
              </div>
              <div className="t m0 x2 h2 y5d ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hc y5e ff1 fs6 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x16 h2 y5f ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h14 y60 ff1 fsa fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 xe h2 y61 ff1 fs0 fc2 sc0 ls0 ws0">
                Our <span className="_ _8" />
                main <span className="_ _8"> </span>ef
                <span className="_ _3" />
                forts <span className="_ _8"> </span>at{" "}
                <span className="_ _9"> </span>IKEA{" "}
                <span className="_ _9"> </span>are{" "}
                <span className="_ _8"> </span>aimed{" "}
                <span className="_ _8"> </span>a<span className="_ _3" />t{" "}
                <span className="_ _9"> </span>prevent
                <span className="_ _3" />
                ing <span className="_ _8"> </span>f<span className="_ _3" />
                ire <span className="_ _8" />
                and <span className="_ _8"> </span>prima
                <span className="_ _3" />
                rily <span className="_ _8"> </span>preve
                <span className="_ _3" />
                nt
                <span className="_ _3" />
                ing <span className="_ _8"> </span>loss{" "}
                <span className="_ _9"> </span>of{" "}
                <span className="_ _8"> </span>life,{" "}
              </div>
              <div className="t m0 xe h2 y62 ff1 fs0 fc2 sc0 ls0 ws0">
                bodily harm, as wel
                <span className="_ _3" />l as loss of a<span className="_ _3" />
                ssets.{" "}
              </div>
              <div className="t m0 x2 h9 y63 ff2 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 xe h2 y64 ff2 fs0 fc2 sc0 lsb ws0">
                In
                <span className="ls0">
                  {" "}
                  case <span className="_ _0" />
                  <span className="lsc">
                    of
                    <span className="ls0">
                      {" "}
                      fire:<span className="ff1"> </span>
                    </span>
                  </span>
                </span>
              </div>
              <div className="t m0 x2 hb y65 ff1 fs5 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 xe h15 y66 ff2 fs7 fc2 sc0 ls0 ws0">
                Rescue<span className="fs0"> </span>
              </div>
              <div className="t m0 x14 ha y67 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Do not block emer
                    <span className="_ _3" />
                    gency exits so that a<span className="_ _3" /> potential eva
                    <span className="_ _3" />
                    cuation would be hin
                    <span className="_ _3" />
                    dered.
                    <span className="_ _2" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x14 ha y68 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Do not cover evacuati
                    <span className="_ _3" />
                    on signs.
                    <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x14 ha y69 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1 fc0">
                    When noticing a bloc
                    <span className="_ _3" />
                    ked emergenc
                    <span className="_ _3" />y exit or fire ext
                    <span className="_ _3" />
                    inguisher, yo
                    <span className="_ _3" />u are respon
                    <span className="_ _3" />
                    sible for{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 y6a ff1 fs0 fc0 sc0 ls0 ws0">
                removing the <span className="_ _0" />
                item(s) as <span className="_ _0" />
                all of <span className="_ _0" />
                us <span className="_ _0" />
                have a <span className="_ _0" />
                mutual <span className="_ _0" />
                responsibility to <span className="_ _0" />
                maintain safety <span className="_ _0" />
                in the{" "}
              </div>
              <div className="t m0 x15 h2 y6b ff1 fs0 fc0 sc0 ls0 ws0">
                workplace. <span className="_ _0" />
                If <span className="_ _d" />
                not <span className="_ _d" />
                able <span className="_ _d" />
                to <span className="_ _d" />
                remove <span className="_ _d" />
                the <span className="_ _0" />
                item(s) <span className="_ _d" />
                yourself, then <span className="_ _d" />
                please <span className="_ _d" />
                contact th
                <span className="_ _0" />e <span className="_ _d" />
                St
                <span className="_ _3" />
                artbox<span className="lsd">. </span>
                <span className="fc2"> </span>
              </div>
              <div className="t m0 x14 h16 y6c ff4 fs6 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _e"> </span>
                  <span className="ff1 fs0 fc0">
                    There <span className="_ _2" />
                    are <span className="_ _8" />
                    several <span className="_ _2" />
                    emerg
                    <span className="_ _3" />
                    encies <span className="_ _2" />
                    ex
                    <span className="_ _3" />
                    its <span className="_ _2" />
                    and <span className="_ _f" />
                    fire <span className="_ _2" />
                    ext
                    <span className="_ _3" />
                    inguishers <span className="_ _2" />i
                    <span className="_ _3" />n <span className="_ _2" />
                    the <span className="_ _f" />
                    building
                    <span className="_ _3" />
                    s. <span className="_ _f" />
                    To <span className="_ _2" />f<span className="_ _3" />
                    ind{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 hc y6d ff1 fs0 fc0 sc0 ls0 ws0">
                out where they are, pleas
                <span className="_ _3" />e <span className="_ _3" />
                look at the eva
                <span className="_ _3" />
                cuation plan located <span className="_ _3" />
                on every floor
                <span className="_ _3" />.<span className="_ _3" />
                <span className="fs6 fc2"> </span>
              </div>
            </div>
            <div className="c x2 y6e w7 he">
              <div className="t m0 x10 hf y47 ff7 fs6 fc1 sc0 ls0 ws0">
                VISITORS<span className="ff9"> </span>
              </div>
            </div>
            <div className="c x12 y6f w7 he">
              <div className="t m0 x10 hf y47 ff7 fs6 fc1 sc0 ls0 ws0">
                FIRE <span className="_ _10" />
                SAFETY<span className="ff9"> </span>
              </div>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.300000,0.000000,0.000000,1.300000,0.000000,0.000000]}'
          />
        </div>
        <div id="pf4" className="pf w0 h0" data-page-no={4}>
          <div className="pc pc4 w0 h0">
            <img
              className="bi x2 y70 w8 h17"
              alt=""
              src="data:image/png;base64,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"
            />
            <div className="c x1 y1 w2 h0">
              <div className="t m0 x2 h7 y4a ff3 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 xe h15 y71 ff2 fs7 fc2 sc0 ls0 ws0">
                Alarm<span className="fs0"> </span>
              </div>
              <div className="t m0 x14 ha y72 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _11"> </span>
                  <span className="ff1">
                    The <span className="_ _2" />
                    office <span className="_ _2" />
                    has <span className="_ _2" />
                    an
                    <span className="_ _3" /> <span className="_ _2" />
                    automatic <span className="_ _2" />
                    fire <span className="_ _2" />
                    alarm. <span className="_ _2" />
                    Notif
                    <span className="_ _3" />y <span className="_ _2" />
                    the <span className="_ _f" />
                    rescue <span className="_ _2" />
                    service <span className="_ _2" />
                    in <span className="_ _2" />
                    case <span className="_ _2" />
                    of <span className="_ _2" />
                    fire <span className="_ _2" />
                    and{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x17 h2 y73 ff1 fs0 fc2 sc0 ls0 ws0">
                smoke.{" "}
              </div>
              <div className="t m0 x14 ha y74 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _11"> </span>
                  <span className="ff1">
                    The fire alarm butto
                    <span className="_ _3" />
                    ns may under no c<span className="_ _3" />
                    ircumstances
                    <span className="_ _3" /> be blocked.
                    <span className="_ _2" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x9 h15 y75 ff2 fs7 fc2 sc0 ls0 ws0">
                Restrict<span className="fs0"> </span>
              </div>
              <div className="t m0 x14 ha y76 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _11"> </span>
                  <span className="ff1">
                    To <span className="_ _8"> </span>restr
                    <span className="_ _3" />
                    ict <span className="_ _8"> </span>fire{" "}
                    <span className="_ _9"> </span>damage{" "}
                    <span className="_ _9"> </span>the{" "}
                    <span className="_ _9"> </span>building{" "}
                    <span className="_ _9"> </span>is{" "}
                    <span className="_ _8"> </span>d<span className="_ _3" />
                    ivided <span className="_ _8"> </span>i
                    <span className="_ _3" />
                    nto <span className="_ _9"> </span>fire{" "}
                    <span className="_ _8"> </span>se
                    <span className="_ _3" />
                    ctions. <span className="_ _8"> </span>D
                    <span className="_ _3" />
                    oors <span className="_ _8"> </span>an
                    <span className="_ _3" />d <span className="_ _8"> </span>ga
                    <span className="_ _3" />
                    tes{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x17 h2 y77 ff1 fs0 fc2 sc0 ls0 ws0">
                between fire sectio
                <span className="_ _3" />
                ns must not be <span className="_ _3" />
                wedged or <span className="_ _3" />
                blocked.
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x9 h15 y78 ff2 fs7 fc2 sc0 ls0 ws0">
                Extinguish
                <span className="lse">
                  er
                  <span className="_ _0" />
                  <span className="fs0 ls0"> </span>
                </span>
              </div>
              <div className="t m0 x14 ha y79 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _11"> </span>
                  <span className="ff1">
                    The <span className="_ _2" />
                    office <span className="_ _2" />
                    is <span className="_ _2" />
                    equ
                    <span className="_ _3" />
                    ipped <span className="_ _2" />w<span className="_ _3" />
                    ith <span className="_ _2" />
                    han
                    <span className="_ _3" />
                    dheld <span className="_ _2" />
                    fi
                    <span className="_ _3" />
                    re <span className="_ _2" />
                    extinguishers, <span className="_ _f" />
                    located <span className="_ _f" />
                    on <span className="_ _2" />
                    each <span className="_ _2" />
                    flo
                    <span className="_ _3" />
                    or, <span className="_ _2" />
                    and{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x17 h2 y7a ff1 fs0 fc2 sc0 ls0 ws0">
                an indoor fire hydrant. <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x14 ha y7b ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _11"> </span>
                  <span className="ff1">
                    Fire extinguishing equi
                    <span className="_ _3" />
                    pment
                    <span className="_ _3" /> <span className="_ _0" />
                    must n<span className="_ _0" />
                    ever <span className="ls8">be</span>{" "}
                    <span className="_ _d" />
                    block
                    <span className="_ _0" />
                    ed.{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 xe h2 y7c ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 xe h15 y7d ff2 fs7 fc2 sc0 ls0 ws0">
                Evacu
                <span className="_ _0" />
                ate{" "}
              </div>
              <div className="t m0 x14 ha y7e ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Leave the unit immediately. <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x14 ha y7f ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Evacuate <span className="_ _8" />
                    through <span className="_ _8" />
                    the <span className="_ _8"> </span>nearest{" "}
                    <span className="_ _8"> </span>em
                    <span className="_ _3" />
                    ergency <span className="_ _f" />
                    ex
                    <span className="_ _3" />
                    it <span className="_ _8" />
                    and <span className="_ _f" />
                    hea
                    <span className="_ _3" />d <span className="_ _8" />
                    to <span className="_ _f" />
                    the <span className="_ _8"> </span>desig
                    <span className="_ _3" />
                    nated
                    <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 y80 ff1 fs0 fc2 sc0 ls0 ws0">
                assembly <span className="_ _d" />
                poi
                <span className="_ _3" />
                nt. Ask Hubh
                <span className="_ _3" />
                ult Support if <span className="_ _3" />
                you are unsure of the <span className="_ _3" />
                location.
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x14 ha y81 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Y
                    <span className="lsf">
                      ou
                      <span className="_ _d" />
                      <span className="ls0">
                        {" "}
                        <span className="ls7">may</span>{" "}
                        <span className="ls10">not</span> l
                        <span className="_ _0" />
                        eav
                        <span className="_ _0" />e the assembly point unless
                      </span>
                    </span>
                  </span>
                </span>
              </div>
              <div className="t m1 x18 h2 y81 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x19 h2 y81 ff1 fs0 fc2 sc0 ls0 ws0">
                otherwise notified <span className="_ _3" />
                by <span className="_ _3" />
                the evacu
                <span className="_ _0" />
                ation{" "}
              </div>
              <div className="t m0 x15 h2 y82 ff1 fs0 fc2 sc0 ls0 ws0">
                leader, <span className="_ _2" />
                wearing <span className="_ _f" />
                an <span className="_ _f" />
                orang
                <span className="_ _0" />e <span className="_ _f" />
                vest, <span className="_ _f" />
                or <span className="_ _f" />
                other <span className="_ _2" />
                rescue <span className="_ _8" />
                team <span className="_ _2" />
                members
                <span className="ls11">
                  , <span className="_ _8" />
                </span>
                wearing <span className="_ _f" />
                yellow
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x15 h2 y83 ff1 fs0 fc2 sc0 ls0 ws0">
                vests.{" "}
              </div>
              <div className="t m0 x15 h2 y84 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x13 h2 y85 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 xe h2 y86 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha y87 ff4 fs0 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    One defibrillator a<span className="_ _3" />
                    nd first aid kit can be <span className="_ _3" />
                    found on ev
                    <span className="_ _3" />
                    ery floor. <span className="_ _2" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 y88 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha y89 ff4 fs0 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff6">
                    You don’t need t<span className="_ _3" />o be train
                    <span className="_ _3" />
                    ed to use a def
                    <span className="_ _3" />
                    ibrillator. <span className="_ _3" />
                    <span className="ff1">
                      It will give <span className="_ _3" />
                      you instructions <span className="_ _3" />
                      in both{" "}
                    </span>
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 y8a ff1 fs0 fc0 sc0 ls0 ws0">
                Swedish and Englis
                <span className="_ _3" />
                h.{" "}
              </div>
              <div className="t m0 x2 h2 y8b ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 xe h2 y8c ff2 fs0 fc2 sc0 ls0 ws0">
                Internal Fire <span className="_ _0" />
                Prevention Group<span className="ff1"> </span>
              </div>
              <div className="t m0 xe h2 y8d ff1 fs0 fc2 sc0 lsa ws0">
                In
                <span className="ls0">
                  {" "}
                  <span className="_ _d" />
                  our <span className="_ _0" />
                  offices <span className="_ _0" />
                  we <span className="_ _d" />
                  have a<span className="_ _0" /> <span className="_ _d" />
                  trained <span className="_ _0" />
                  fire <span className="_ _d" />
                  and <span className="_ _0" />
                  rescue <span className="_ _0" />
                  team <span className="_ _0" />
                  as <span className="_ _0" />a <span className="_ _0" />
                  complement <span className="_ _d" />
                  to <span className="_ _2" />
                  the fire <span className="_ _d" />
                  department.{" "}
                </span>
              </div>
              <div className="t m0 xe h2 y8e ff1 fs0 fc2 sc0 ls0 ws0">
                When the fire alarm sounds the team follows evacu
                <span className="_ _3" />
                ation instructions.
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x2 h2 y8f ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x1a h2 y90 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x15 h2 y91 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha y92 ff4 fs0 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    If you leave y<span className="_ _3" />
                    our sta
                    <span className="_ _3" />
                    tion/sea
                    <span className="_ _3" />
                    t/equipment, a<span className="_ _3" />
                    lways lock y<span className="_ _3" />
                    our computer <span className="_ _3" />
                    by pres
                    <span className="_ _3" />
                    sing the{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 y93 ff1 fs0 fc0 sc0 ls0 ws0">
                windows-button + <span className="_ _3" />L or by closing the{" "}
                <span className="_ _3" />
                lid.
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x2 h18 y94 ff1 fsb fc2 sc0 ls0 ws0"> </div>
            </div>
            <div className="c x2 y95 w7 he">
              <div className="t m0 x10 hf y47 ff7 fs6 fc1 sc0 ls0 ws0">
                OTHER E<span className="_ _0" />
                MERGEN
                <span className="_ _0" />
                CY PROCE
                <span className="_ _0" />
                DURES<span className="ff9"> </span>
              </div>
            </div>
            <div className="c xe y96 w9 h19">
              <div className="t m0 x10 hf y97 ff7 fs6 fc1 sc0 ls0 ws0">
                INFORMATION SECURI
                <span className="_ _0" />
                TY<span className="ff9"> </span>
              </div>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.300000,0.000000,0.000000,1.300000,0.000000,0.000000]}'
          />
        </div>
        <div id="pf5" className="pf w0 h0" data-page-no={5}>
          <div className="pc pc5 w0 h0">
            <div className="c x1 y1 w2 h0">
              <div className="t m0 x2 h7 y4a ff3 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha y2 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Change your passw
                    <span className="_ _3" />
                    ord at least once ever
                    <span className="_ _3" />y three months or
                    <span className="_ _3" /> <span className="_ _3" />
                    when <span className="_ _0" />
                    requested.{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x2 h1a y98 ff1 fsc fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha y99 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Do <span className="_ _2" />
                    not <span className="_ _2" />
                    use <span className="_ _2" />
                    passwords <span className="_ _2" />
                    tha
                    <span className="_ _3" />t <span className="_ _2" />
                    relate <span className="_ _2" />
                    to <span className="_ _f" />
                    yourself. <span className="_ _2" />
                    Use <span className="_ _2" />a <span className="_ _2" />
                    combination <span className="_ _2" />
                    <span className="ls6">
                      of
                      <span className="_ _3" />
                    </span>{" "}
                    <span className="_ _2" />
                    letters, <span className="_ _2" />
                    digits{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 y9a ff1 fs0 fc2 sc0 ls0 ws0">
                and special signs.{" "}
              </div>
              <div className="t m0 x2 hb y9b ff1 fs5 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha y9c ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Do not share your pa
                    <span className="_ _3" />
                    ssword <span className="_ _3" />
                    with anyone else.
                    <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x2 h1b y9d ff1 fsd fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha y9e ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Never leave sensitive/c
                    <span className="_ _3" />
                    onfident
                    <span className="_ _3" />
                    ial documents visib
                    <span className="_ _3" />
                    le.
                    <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x2 h2 y9f ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x1b ha ya0 ff9 fs0 fc2 sc0 ls0 ws0">
                -
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1 ls12">
                    Be
                    <span className="ls0">
                      {" "}
                      <span className="_ _12"> </span>careful{" "}
                      <span className="_ _12"> </span>
                      <span className="ls13">in</span>{" "}
                      <span className="_ _12"> </span>the{" "}
                      <span className="_ _12"> </span>use{" "}
                      <span className="_ _12"> </span>
                      <span className="ls6">of</span>{" "}
                      <span className="_ _12"> </span>USB
                      <span className="_ _3" /> <span className="_ _12"> </span>
                      sticks <span className="_ _12"> </span>(permi
                      <span className="_ _0" />
                      tted <span className="_ _12"> </span>only{" "}
                      <span className="_ _12"> </span>
                      <span className="ls13">in</span>{" "}
                      <span className="_ _13"> </span>ICC{" "}
                    </span>
                  </span>
                </span>
              </div>
              <div className="t m0 x1c h2 ya1 ff1 fs0 fc2 sc0 ls0 ws0">
                computers).
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x1b ha ya2 ff9 fs0 fc2 sc0 ls0 ws0">
                -
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Put away <span className="_ _7"> </span>your laptop{" "}
                    <span className="_ _7"> </span>when you l
                    <span className="_ _0" />
                    eave
                    <span className="_ _3" /> <span className="_ _7"> </span>the
                    office for <span className="_ _7"> </span>the day.{" "}
                    <span className="_ _6"> </span>When
                    <span className="_ _3" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x1c h2 ya3 ff1 fs0 fc2 sc0 ls0 ws0">
                traveling, <span className="_ _2" />
                <span className="ls8">be</span> <span className="_ _2" />
                careful <span className="_ _2" />
                <span className="ls6">on</span> <span className="_ _2" />
                th
                <span className="_ _0" />e <span className="_ _2" />
                train, <span className="_ _2" />
                plane, <span className="_ _2" />
                etc, <span className="_ _3" />
                <span className="ls9">so</span> <span className="_ _2" />
                that <span className="_ _2" />
                you
              </div>
              <div className="t m1 x1d h2 ya3 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 xa h2 ya3 ff1 fs0 fc2 sc0 ls8 ws0">
                do
                <span className="ls0">
                  {" "}
                  <span className="_ _2" />
                  not <span className="_ _2" />d<span className="_ _3" />
                  isplay{" "}
                </span>
              </div>
              <div className="t m0 x1c h2 ya4 ff1 fs0 fc2 sc0 ls0 ws0">
                sensitive <span className="_ _8"> </span>information.
                <span className="_ _3" /> <span className="_ _f" />
                If
                <span className="_ _3" /> <span className="_ _8"> </span>you{" "}
                <span className="_ _8" />
                lose <span className="_ _8"> </span>your{" "}
                <span className="_ _8"> </span>laptop,{" "}
                <span className="_ _9"> </span>notify{" "}
                <span className="_ _8"> </span>Service{" "}
                <span className="_ _8"> </span>Des
                <span className="_ _3" />k <span className="_ _8" />
                and{" "}
              </div>
              <div className="t m0 x1c h2 ya5 ff1 fs0 fc2 sc0 ls0 ws0">
                your HR-depa
                <span className="_ _3" />
                rtment as soon as poss
                <span className="_ _3" />
                ible.
              </div>
              <div className="t m0 x1e h1b ya6 ff1 fsd fc2 sc0 ls0 ws0">
                {" "}
                <span className="_ _14"> </span>{" "}
                <span className="_ _15"> </span>{" "}
                <span className="_ _15"> </span>{" "}
              </div>
              <div className="t m0 x1c h1b ya7 ff1 fsd fc2 sc0 ls0 ws0">
                {" "}
                <span className="_ _16"> </span>{" "}
              </div>
              <div className="t m0 x1f h2 ya8 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha ya9 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Each <span className="ls3">co</span>-worker{" "}
                    <span className="ls13">is</span> person
                    <span className="_ _0" />
                    ally <span className="_ _3" />
                    responsible for the information
                    <span className="_ _0" /> they
                  </span>
                </span>
              </div>
              <div className="t m1 xa h2 ya9 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x20 h2 ya9 ff1 fs0 fc2 sc0 ls0 ws0">
                create <span className="_ _9"> </span>and{" "}
                <span className="_ _9"> </span>receive{" "}
              </div>
              <div className="t m0 x15 h2 yaa ff1 fs0 fc2 sc0 ls0 ws0">
                and <span className="_ _6"> </span>must{" "}
                <span className="_ _9"> </span>make{" "}
                <span className="_ _6"> </span>sure{" "}
                <span className="_ _6"> </span>
                <span className="ls13">it</span> <span className="_ _6"> </span>
                <span className="ls13">is</span> <span className="_ _9"> </span>
                handled <span className="_ _6"> </span>
                <span className="ls13">in</span> <span className="_ _6"> </span>
                a <span className="_ _6"> </span>safe
              </div>
              <div className="t m1 x21 h2 yaa ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x22 h2 yaa ff1 fs0 fc2 sc0 ls0 ws0">
                manner, <span className="_ _a"> </span>
                <span className="ls5">to</span> <span className="_ _14"> </span>
                prevent <span className="_ _14"> </span>the{" "}
                <span className="_ _14"> </span>information{" "}
              </div>
              <div className="t m0 x15 h2 yab ff1 fs0 fc2 sc0 ls0 ws0">
                spreading <span className="_ _14"> </span>
                <span className="ls5">to</span> <span className="_ _a"> </span>
                una
                <span className="_ _3" />
                uthorized <span className="_ _9"> </span>persons.
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x2 h2 yac ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha yad ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    The <span className="_ _d" />
                    use <span className="_ _d" />
                    of <span className="_ _d" />
                    private <span className="_ _d" />
                    data
                    <span className="_ _3" /> <span className="_ _d" />
                    such <span className="_ _d" />
                    as <span className="_ _d" />m<span className="_ _3" />
                    usic, <span className="_ _d" />
                    movies <span className="_ _d" />
                    and <span className="_ _d" />
                    pictures <span className="_ _d" />
                    on <span className="_ _d" />
                    IKEA <span className="_ _0" />
                    computers{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 yae ff1 fs0 fc2 sc0 ls0 ws0">
                is not allowed. These <span className="_ _3" />
                sho
                <span className="_ _3" />
                uld also not be saved <span className="_ _3" />
                on the IKEA netwo
                <span className="_ _3" />
                rk.
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x2 h3 yaf ff1 fs1 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha yb0 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Each <span className="_ _0" />
                    <span className="ls3">
                      co
                      <span className="ls0">
                        -worker <span className="_ _d" />
                        has{" "}
                        <span className="ls4">
                          an
                          <span className="_ _0" />
                          <span className="ls0">
                            {" "}
                            ob
                            <span className="_ _0" />
                            ligation <span className="_ _0" />
                            <span className="ls5">
                              to
                              <span className="ls0">
                                {" "}
                                report <span className="_ _d" />s
                                <span className="_ _3" />
                                uspecte
                                <span className="_ _3" />d{" "}
                                <span className="_ _0" />
                                security
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </div>
              <div className="t m1 x23 h2 yb0 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x24 h2 yb0 ff1 fs0 fc2 sc0 ls0 ws0">
                risks.{" "}
              </div>
              <div className="t m0 x2 hb yb1 ff1 fs5 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha yb2 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    It is <span className="_ _d" />
                    every <span className="ls3">co</span>-
                    <span className="ff6">worker’s</span> respon
                    <span className="_ _0" />
                    sibility for the <span className="_ _d" />
                    sa
                    <span className="_ _3" />
                    fety o<span className="_ _0" />f their{" "}
                    <span className="_ _d" />
                    informati
                    <span className="_ _3" />
                    on, such a<span className="_ _0" />s ID{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 yb3 ff1 fs0 fc2 sc0 ls0 ws0">
                cards, passwords, PINs
                <span className="_ _3" />, USB <span className="_ _3" />
                sticks, etc.
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x2 hb yb4 ff1 fs5 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha yb5 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    When <span className="_ _0" />
                    gaining access <span className="ls5">to</span> the in
                    <span className="_ _0" />
                    ternet, you
                    <span className="_ _0" /> need to sig
                    <span className="_ _3" />n a contract betwee
                    <span className="_ _3" />n the{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 yb6 ff1 fs0 fc2 sc0 ls0 ws0">
                company/manager a<span className="_ _3" />
                nd the employee.
                <span className="_ _2" />{" "}
              </div>
              <div className="t m0 x15 h2 yb7 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha yb8 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Every <span className="_ _d" />
                    <span className="ls3">
                      co
                      <span className="ls0">
                        -worker <span className="ls13">is</span>{" "}
                        <span className="_ _0" />
                        responsible for <span className="_ _d" />
                        ens
                        <span className="_ _3" />
                        uring that <span className="_ _d" />t
                        <span className="_ _3" />
                        he IKEA
                      </span>
                    </span>
                  </span>
                </span>
              </div>
              <div className="t m1 x25 h2 yb8 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x26 h2 yb8 ff1 fs0 fc2 sc0 lsa ws0">
                IT
                <span className="ls0">
                  {" "}
                  equipment is o<span className="_ _3" />
                  nly{" "}
                </span>
              </div>
              <div className="t m0 x15 h2 yb9 ff1 fs0 fc2 sc0 ls0 ws0">
                used for work purposes
                <span className="_ _3" /> and not for pri
                <span className="_ _3" />
                vate use. <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x15 h2 yba ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha ybb ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    It <span className="_ _3" />
                    is <span className="_ _2" />
                    not allowed <span className="_ _3" />
                    to <span className="_ _2" />
                    send <span className="_ _3" />
                    chain <span className="_ _3" />
                    lette
                    <span className="_ _3" />
                    rs <span className="_ _3" />
                    or <span className="_ _2" />
                    similar <span className="_ _3" />
                    materials <span className="_ _2" />
                    <span className="ls8">by</span> <span className="_ _3" />
                    ma
                    <span className="_ _3" />
                    il, <span className="_ _8"> </span>or{" "}
                    <span className="_ _3" />i<span className="_ _3" />n{" "}
                    <span className="_ _3" />
                    other <span className="_ _2" />
                    ways,
                    <span className="_ _0" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 ybc ff1 fs0 fc2 sc0 ls0 ws0">
                within the IKE
                <span className="_ _d" />A network.
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x15 h2 ybd ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 ybe ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 ybf ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 yc0 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 yc1 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 yc2 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 y6c ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 h2 yc3 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.300000,0.000000,0.000000,1.300000,0.000000,0.000000]}'
          />
        </div>
        <div id="pf6" className="pf w0 h0" data-page-no={6}>
          <div className="pc pc6 w0 h0">
            <img
              className="bi x2 yc4 wa h1c"
              alt=""
              src="data:image/png;base64,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"
            />
            <div className="c x1 y1 w2 h0">
              <div className="t m0 x2 h7 y4a ff3 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x13 h2 yc5 ff1 fs0 fc0 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha yc6 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    T<span className="_ _d" />
                    ak
                    <span className="_ _d" />e <span className="_ _0" />
                    care <span className="ls6">of</span> yours
                    <span className="_ _0" />
                    elf - <span className="_ _0" />
                    safety <span className="ls13">is</span>{" "}
                    <span className="_ _0" />
                    always the top priority
                    <span className="_ _3" />.{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 yc7 ff1 fs0 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha yc8 ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    During <span className="_ _2" />
                    wintertime <span className="_ _2" />
                    it <span className="_ _3" />
                    can <span className="_ _2" />
                    be <span className="_ _2" />
                    slippery <span className="_ _2" />
                    ou
                    <span className="_ _0" />
                    tdoors.
                    <span className="_ _3" /> <span className="_ _2" />
                    <span className="ls14">We</span> <span className="_ _2" />
                    deice <span className="_ _3" />a<span className="_ _3" />s{" "}
                    <span className="_ _2" />
                    soon <span className="_ _9"> </span>
                    <span className="ls4">as</span> <span className="_ _3" />
                    possible, <span className="_ _3" />
                    but{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 yc9 ff1 fs0 fc2 sc0 ls0 ws0">
                tread carefully <span className="_ _d" />a
                <span className="_ _3" />
                nd pay <span className="_ _d" />a<span className="_ _3" />
                ttention.{" "}
              </div>
              <div className="t m0 x14 hc yca ff1 fs6 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha ycb ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    Don´t leave your val
                    <span className="_ _3" />
                    uables unattended.
                    <span className="_ _2" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x14 hc ycc ff1 fs6 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 ha ycd ff4 fs0 fc2 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _5"> </span>
                  <span className="ff1">
                    All <span className="_ _8" />
                    accidents <span className="_ _8"> </span>and/
                    <span className="_ _3" />
                    or <span className="_ _8"> </span>incidents
                    <span className="_ _3" /> <span className="_ _8"> </span>sho
                    <span className="_ _3" />
                    uld <span className="_ _8" />
                    be <span className="_ _8"> </span>repor
                    <span className="_ _3" />
                    ted <span className="_ _8"> </span>to{" "}
                    <span className="_ _8"> </span>your{" "}
                    <span className="_ _9"> </span>immediate supervisor
                    <span className="_ _c" />{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 yce ff1 fs0 fc2 sc0 ls0 ws0">
                and <span className="_ _2" />
                Hubhult <span className="_ _f" />
                security. <span className="_ _f" />
                An <span className="_ _2" />
                incident <span className="_ _f" />
                report <span className="_ _2" />
                sho
                <span className="_ _3" />
                uld <span className="_ _2" />
                always <span className="_ _f" />
                be <span className="_ _f" />
                filled <span className="_ _2" />
                in. <span className="_ _2" />
                You <span className="_ _f" />
                can <span className="_ _2" />
                find{" "}
              </div>
              <div className="t m0 x15 h2 ycf ff1 fs0 fc2 sc0 ls0 ws0">
                the incident report on I<span className="_ _3" />
                nside.
                <span className="_ _3" />{" "}
              </div>
              <div className="t m0 x14 hc yd0 ff1 fs6 fc2 sc0 ls0 ws0"> </div>
              <div className="t m0 x14 h1d yd1 ff4 fs7 fc0 sc0 ls0 ws0">
                •
                <span className="ff5">
                  {" "}
                  <span className="_ _17"> </span>
                  <span className="ff1 fs0 fc2">
                    You <span className="_ _2" />
                    can <span className="_ _f" />
                    only <span className="_ _2" />e<span className="_ _3" />
                    nter <span className="_ _2" />t<span className="_ _3" />
                    he <span className="_ _2" />
                    of
                    <span className="_ _3" />
                    fice <span className="_ _f" />
                    on <span className="_ _2" />
                    wor
                    <span className="_ _3" />
                    kdays <span className="_ _2" />
                    be
                    <span className="_ _3" />
                    tween <span className="_ _f" />
                    the <span className="_ _f" />
                    hours <span className="_ _2" />0<span className="_ _2" />
                    5.00 <span className="_ _2" />
                    <span className="ff6">–</span> <span className="_ _f" />
                    21.00. <span className="_ _2" />
                    On{" "}
                  </span>
                </span>
              </div>
              <div className="t m0 x15 h2 yd2 ff1 fs0 fc2 sc0 ls0 ws0">
                weekends <span className="_ _f" />a<span className="_ _3" />
                nd <span className="_ _f" />
                Swedish <span className="_ _8" />
                holidays, <span className="_ _f" />
                the <span className="_ _8" />
                office <span className="_ _f" />
                is <span className="_ _8" />
                closed. <span className="_ _f" />
                If <span className="_ _8" />
                you <span className="_ _f" />
                are <span className="_ _f" />
                in <span className="_ _f" />
                need <span className="_ _8" />
                to <span className="_ _f" />
                work{" "}
              </div>
              <div className="t m0 x15 h2 yd3 ff1 fs0 fc2 sc0 ls0 ws0">
                outside <span className="_ _2" />
                office <span className="_ _2" />
                hou
                <span className="_ _3" />
                rs, <span className="_ _2" />
                send <span className="_ _2" />a <span className="_ _f" />
                request <span className="_ _2" />
                to <span className="_ _f" />
                <span className="fc4">
                  facility.se
                  <span className="_ _3" />
                  rvices@ikea.com
                  <span className="_ _3" />
                </span>{" "}
                <span className="_ _2" />
                at <span className="_ _2" />
                least <span className="_ _f" />3 <span className="_ _2" />
                days{" "}
              </div>
              <div className="t m0 x15 h15 yd4 ff1 fs0 fc2 sc0 ls0 ws0">
                before.<span className="ff2 fs7 fc0"> </span>
              </div>
              <div className="t m0 x2 hd yd5 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd yd6 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd yd7 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd yd8 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd yd9 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd yda ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ydb ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ydc ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ydd ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd yde ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ydf ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ye0 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ye1 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ye2 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ye3 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ye4 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ye5 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ye6 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ye7 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ye8 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
              <div className="t m0 x2 hd ye9 ff1 fs7 fc5 sc0 ls0 ws0"> </div>
            </div>
            <div className="c x2 yea w7 h1e">
              <div className="t m0 x10 hf y47 ff7 fs6 fc1 sc0 ls15 ws0">
                TO
                <span className="ls0">
                  {" "}
                  <span className="_ _d" />
                  THI
                  <span className="_ _3" />
                  NK <span className="_ _0" />
                  ABOUT!<span className="ff9"> </span>
                </span>
              </div>
            </div>
            <a className="l" href="mailto:facility.services@ikea.com">
              <div
                className="d m2"
                style={{
                  borderStyle: "none",
                  position: "absolute",
                  left: "406.016000px",
                  bottom: "653.328000px",
                  width: "125.970000px",
                  height: "15.660000px",
                  backgroundColor: "rgba(255,255,255,0.000001)",
                }}
              />
            </a>
          </div>

          











          <div style={{position: 'relative', left: '500px', top: '50%', transform: 'translate(-50%)'}}>
          <div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div>
          <div style={{ display: "flex", marginBottom: '10px' }}>
            <Checkbox
              style={{ marginRight: "14px", marginLeft: "30px", height: '40px' }}
              checked={checked}
              onChange={handleChange}
              name="checkedB"
              color="primary"
            />
            <Typography variant="subtitle2">
              <p style={{ width: "400px", height: '40px', margin: '0px' }}>
                By checking the check box I confirm that I have read through the
                "Safety & security information" document.
              </p>
            </Typography>
          </div>
          <div style={{ display: 'flex', width: '400px', justifyContent: 'space-between', height: '40px' }}>
            <Button

              disabled={checked ? false : true}
              onClick={sendForm}
              style={{ marginLeft: "30px", marginRight: '30px', width: '300px' }}
              color="primary"
              variant="contained"
            >
              Confirm
            </Button>
            {isLoading ? <div>
              <CircularProgress />
            </div> : <div></div>}
          </div>

        </div>
      </form>


      <div style={{ color: 'red', marginLeft: "30px", marginTop: '20px', height: '30px' }}>
        <Typography variant="subtitle2">{errorMsg}</Typography>
      </div>

    </div>
          </div>














          <div
            className="pi"
            data-data='{"ctm":[1.300000,0.000000,0.000000,1.300000,0.000000,0.000000]}'
          />
        </div>

     
        
        <div className="loading-indicator">
          <img
            alt=""
            src="data:image/png;base64,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"
          />
        </div>
        
        
      </div>








    </div>
  );
};

export default PDF;
